import { homeReducer, initialHomeState } from '../pages/home/state/Reducer';
import {
  productReducer,
  initialProductState,
} from '../pages/allProducts/state/Reducers';
import {
  githubReducer,
  initialGithubState,
} from '../pages/githubCode/states/Reducers';
import { authReducer, initialAuthState } from '../pages/auth/state/Reducer';

export const initialAppState = {
  homeState: initialHomeState,
  productState: initialProductState,
  githubState: initialGithubState,
  authState: initialAuthState,
};

export function rootReducer(state, action) {
  return {
    // orderState: orderReducer(state.orderState, action),
    githubState: githubReducer(state.githubState, action),
    homeState: homeReducer(state.homeState, action),
    productState: productReducer(state.productState, action),
    authState: authReducer(state.authState, action),
  };
}
